import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ButtonDownloadEInvoice from "../_common/buttonDownloadEInvoice";
import ButtonDownloadStandard from "../_common/buttonDownloadStandard";

const FooterList = props => {
  const {
    documentId,
    filename,
    getDownload,
    handleClick,
    isEinvoice,
    subtitle,
    notesCount
  } = props;

  const styleDownloadBtn = {
    margin: 10
    // height: "100%",
    // verticalAlign: "middle",
    // zIndex: 99,
    // width: "50%",
    // padding: "50% 10px"
  };
  return (
    <div className="footerBox">
      <div className="footer-list-container" >
        <div>
          {notesCount !== 0 && <div className="footer-list-notes-counter">
            {parseInt(notesCount) > 100 ? "99+" : notesCount}
          </div>}
          <FontAwesomeIcon
            icon={["far", "comment-alt"]}
            className="footer-list-notes-icon"
          />
        </div>
        <div
          className="footer-list-eye"
          onClick={e => {
            // se ho il subtitle lo metto in local storage così da averlo nel dettaglio
            handleClick(
              e, documentId, subtitle
            );
          }}
        >
          <FontAwesomeIcon
            icon={["far", "eye"]}
          />
        </div>
        {isEinvoice ? (
          <ButtonDownloadEInvoice
            getDownload={getDownload}
            documentId={documentId}
            filename={filename}
            isEinvoice={isEinvoice}
            style={styleDownloadBtn}
          />
        ) : (
          <ButtonDownloadStandard
            documentId={documentId}
            filename={filename}
            getDownload={getDownload}
            style={styleDownloadBtn}
          />
        )}
      </div>
    </div>
  );
};

export default FooterList;
